<template>
  <div class="SecurityScore">
    <Title firstName="楼宇安防评分" lastName="SECURITY SCORE" />
    <div class="echarts">
      <div
        id="SecurityScore"
        ref="echarts"
        style="height: 25.5vh;"
      />
      <div class="rate">
          <div class="tt">综合评分</div>
          <div class="num">--<span>分</span></div>
      </div>
      <div class="bottom"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
const Title = () => import("../../../../components/title/Title");
let myChart = null
export default {
    data() {
        return {
        };
    },
    components: {
        Title,
    },
    mounted() {
        this.initCharts();
        window.addEventListener('resize',this.chartResize)
        window.addEventListener('beforeunload', this.clearChart);
    },
  methods: {
        clearChart(){
            // 手动触发 destroy 相关的生命周期
            this.$destroy();
        },
        chartResize(){
            //防抖
            if(this.timer)
                clearTimeout(this.timer)
            this.timer = setTimeout(()=>{
                myChart.resize();
            },500)
        },
    initCharts() {
            myChart = echarts.getInstanceByDom(document.getElementById("SecurityScore"));
            if(myChart == null){
                myChart = echarts.init(document.getElementById("SecurityScore"));
            }

      var option;
      let color = ["#5B8FF9", "#F6BD16", "#E8684A", "#FF9D4D", "#269A99"];
      option = {
        color: color,
        angleAxis: {
          type: "category",
          data: ["", "", "", "", "", "", ""],
        },
        tooltip: {
            show:true,
            trigger: 'item',
            formatter: "{a}: {c}",
            backgroundColor: 'rgba(0, 10, 26, 0.8)',
            borderRadius: 8,  
            borderWidth: 0,
            shadowColor:'rgba(13, 148, 255, 0.8)',
            axisPointer: {// 坐标轴指示器，坐标轴触发有效
              type: 'line', // 默认为直线，可选为：'line' | 'shadow'
            },
            textStyle: {
                color: '#fff'
            },
        },
        radiusAxis: {
            splitLine: {
                lineStyle: {
                    color:['rgba(225, 225, 225, 0.1)']
                },
            },
            splitArea: {
                show: false,
            },
            axisLine: {
                lineStyle: {
                    color: "rgba(225, 225, 225, 0.6)",
                },
            },
        },
        polar: {
            center: ['32%', '50%']
        },
        series: [
          {
            type: "bar",
            data: [1, 2, 3, 4, 3, 5, 1],
            coordinateSystem: "polar",
            name: "人员管理",
            stack: "a",
            emphasis: {
              focus: "series",
            },
          },
          {
            type: "bar",
            data: [2, 4, 6, 1, 3, 2, 1],
            coordinateSystem: "polar",
            name: "门岗管理",
            stack: "a",
            emphasis: {
              focus: "series",
            },
          },
          {
            type: "bar",
            data: [1, 2, 3, 4, 1, 2, 5],
            coordinateSystem: "polar",
            name: "报警监控",
            stack: "a",
            emphasis: {
              focus: "series",
            },
          },
          
          {
            type: "bar",
            data: [1, 2, 3, 4, 1, 2, 5],
            coordinateSystem: "polar",
            name: "巡更管理",
            stack: "a",
            emphasis: {
              focus: "series",
            },
          },
          {
            type: "bar",
            data: [1, 2, 3, 4, 1, 2, 5],
            coordinateSystem: "polar",
            name: "视频监控",
            stack: "a",
            emphasis: {
              focus: "series",
            },
          }
        ],
        legend: {
          orient: "vertical", //垂直显示
            y: "35%", //延Y轴居中
            right:"5%", //居右显示
            icon: "roundRect",
            itemWidth: 8,
            itemHeight: 8,
            textStyle: {
                color:"#E6F3FD",
                fontSize:"14rem",
                rich:{
                    a:{
                        fontSize:"20rem",
                        color:"#00DEFF",
                        verticalAlign:'top',
                        align:'center',
                        fontFamily:"zcoolqingkehuangyouti"
                    },
                    b:{
                        fontSize:"14rem",
                        color:"#00DEFF",
                        align:'center',
                        fontFamily:"zcoolqingkehuangyouti"
                    }
                }
            },
            formatter: function (name) {
                return name+' : {a|--}{b|分}';
            },
        },
      };

      myChart.clear();
      option && myChart.setOption(option);
      window.onresize = function () {
        myChart.resize();
      };
    },
  },
    // watch: {
    //     routeName(){
    //     myChart = null
    //     this.initCharts();
    //     }
    // },
    beforeDestroy(){
        window.removeEventListener('resize', this.chartResize);
        window.removeEventListener('beforeunload', this.clearChart);
        if(!myChart) return 
        myChart.clear()
        myChart = null;
    }
};
</script>

<style lang="less" scoped>
.SecurityScore {
  // height: 33.3vh;
  width: 20vw;
  // height: 493rem;
  position: fixed;
  top: 31.2vh;
  left: 2vw;
  z-index: 1;

   
  .echarts {
    position: relative;
    height: 25.5vh;
    padding-bottom: 1vh;
    background: linear-gradient(
      0deg,
      rgba(0, 33, 59, 0.6) 0%,
      rgba(3, 13, 24, 0.7) 100%
    );

    .rate{
        color: #E6F3FD;
        font-size: 14rem;
        position: absolute;
        top: 20px;
        right: 30px;
        width: 100rem;
        text-align: center;
        .num{
            color: #00DEFF;
            font-size: 20rem;
            font-family: zcoolqingkehuangyouti;
            margin-top: 8rem;
            span{
                font-size: 14rem;
            }
        }
    }

    .bottom {
      width: 20vw;
      height: 1vh;
      background: url(../../../../assets/img/板块装饰线.png) no-repeat;
      block-size: 100% 100%;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
}
.power1 {
  top: 30.3vh;
}
</style>
